module.exports = __webpack_public_path__ + "img/image-thumb-23.cabe3408.jpg";